import { render, staticRenderFns } from "./FormFarm.vue?vue&type=template&id=9fd73f90&"
import script from "./FormFarm.vue?vue&type=script&lang=js&"
export * from "./FormFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports